<template>
	<div>
		<!--灰条-->
		<div style=" background-color: #F5F5F5 ;height: 0.2rem"></div>
		<div style="width:92% ; margin:0 auto 0 auto " v-for="item in orderList">
			<div v-on:click=" goDetail(item.ParentResvNo  , item.TotalPrice , '取消订单'  ) " class="Grey">
				<div style="width:100%  ;  height:0.7rem  ; ">
					<span class="Orange" style="margin-left:5px ;margin-top:10px ;font-weight:700;font-size:0.28rem ; float:left">
						<div>{{orderState(item)}}</div>
					</span>
					<span style="margin-right:10px ; margin-top:10px ;font-size:0.24rem ; float:right  ">
						查看详情
						<mu-icon value="keyboard_arrow_right" color="#D4D4D4" :size='16' style="position:relative;top:4px;" />
					</span>
				</div>
				<!--线条-->
				<hr style="border:none; border-top:1px solid #F1F1F1;"></hr>
				<table style="width:100%" align="center" border="0">
					<tr>
						<td style="width:26% ;  ">
							<img :src="item.HotelLogo!=''?item.HotelLogo:'../../../static/search/noImg.jpg' " style=" max-height:1.2rem ; max-width:1.6rem ; margin:-5% 0 0 -5%;" />
						</td>
						<td>
							<div style="color:#333333 ; font-weight:700 ; width:98%"> {{ item.HotelName }} </div>
							<div style=" padding-top:0.1rem;   line-height:1.6 ; font-size:0.22rem  ; float:left ;">
								入住： {{ item.Arrivedate | dayTime }}
								<br /> 离开： {{ item.Departuredate | dayTime }}
								<br /> 房型： {{ item.RoomTypeNameNew+'(' + item.RoomTypeDisPlayNew+')' }} × {{item.RoomCount}}
							</div>
							<div style="color:#333333  ; float:right ; margin:0.2rem 0.15rem 0 0 ">
								<span style="font-size:0.26rem ;   "> ￥ </span>
								<span style="font-size:0.32rem ;   "> {{item.TotalPrice}} </span>
							</div>
						</td>
					</tr>
				</table>
				<!--线条-->
				<hr style="border:none; border-top:1px solid #F1F1F1;"></hr>

				<!-- 特惠房和休闲房是预定的订单只保留半小时。 显示的不一样   -->
				<!-- 0 = 常规房 2 = 活动房 -->
				<div v-if="item.OtherFlag == 0 || item.OtherFlag == 2 ">

					<!--已支付-->
					<div v-if=" item.listResvPayInfo[0].PayStatus =='0' " style="text-align:left; font-size:0.21rem  ;  margin-top:0.2rem ; margin-bottom:0.2rem" >
						备注：如遇特殊情况，不能及时入住，您可以在
						<!-- 998 69 特别 提前一天 -->
						<span class="Orange"   v-if="item.SpecialCode == 'C0000001' || item.SpecialCode == 'C0000075' || item.SpecialCode == 'C0000187'   ">【入住日前一天】18:00 </span>
						<span class="Orange"  v-else>【入住当日】18:00 </span>
						前免费取消订单。若未入住或逾期取消，将收取您首日房费。
					</div>
					<!--未支付-->
					<div v-else>
						<!-- 非活动房 -->
						<div v-if="  item.SpecialCode == '' " style="text-align:left; font-size:0.21rem  ;  margin-top:0.2rem ; margin-bottom:0.2rem" >
							备注：如您到店较晚，建议您先支付房费，我们将为您保留房间至
							<span class="Orange"  v-if=" CardKindDiplay == '员工卡' || CardKindDiplay == '数字卡' || CardKindDiplay == '贵宾卡' ">离店日 13:00 </span>
							<span class="Orange"  v-if="CardKindDiplay == '贝壳卡' || CardKindDiplay == '铂金卡' || CardKindDiplay == '金卡' || CardKindDiplay == '翡翠卡' || CardKindDiplay == '联名卡' ">离店日 14:00 </span>
							，期间可随时入住。
							<span class="Orange"  >【入住当日】18:00 </span>
							之前取消订单可全额退款。超时或未入住将收取您首日房费。
						</div>

						<div v-else-if = " item.SpecialCode == 'C0000001' || item.SpecialCode == 'C0000075'  || item.SpecialCode == 'C0000187'  " style="text-align:left; font-size:0.21rem  ;  margin-top:0.2rem ; margin-bottom:0.2rem">
							备注：998房或69房需要在30分钟内完成支付，未完成支付将自动取消。支付成功后只能在入住日前一天18:00前免费取消，逾期取消或未入住需收取全额房费作为违约金。
						</div>

						<!-- 这段是未支付状态，但是还有个交易中状态 2 -->
						<div v-else style="text-align:left; font-size:0.21rem  ;  margin-top:0.2rem ; margin-bottom:0.2rem">
							备注：特价房需要在30分钟内完成支付，未完成支付将自动取消。
						</div>

					</div>

				</div>

				<div v-if="item.listResvPayInfo">
				<!-- {{  item.HoldTimeStr  }} -->
				<!-- 休闲房 -->
					<div v-if=" item.OtherFlag == 1 ">
						<div style="text-align:left; font-size:0.21rem  ;  margin-top:0.2rem ; margin-bottom:0.2rem" v-if=" item.listResvPayInfo[0].PayStatus =='0' ">
							备注：休闲房订单取消需提前到达时间4小时以上！
						</div>
						<div style="text-align:left; font-size:0.21rem  ;  margin-top:0.2rem ; margin-bottom:0.2rem" v-if=" item.listResvPayInfo[0].PayStatus !='0' ">
							备注：休闲房需在30分钟内完成支付，未完成支付将自动取消。
						</div>
					</div>

					<!-- 凌晨房 -->
					<div v-if=" item.OtherFlag == 4 ">
						<div style="text-align:left; font-size:0.21rem  ;  margin-top:0.2rem ; margin-bottom:0.2rem" v-if=" item.listResvPayInfo[0].PayStatus =='0' ">
							备注：已支付凌晨房订单将保留至中午十二点。
						</div>
						<div style="text-align:left; font-size:0.21rem  ;  margin-top:0.2rem ; margin-bottom:0.2rem" v-if=" item.listResvPayInfo[0].PayStatus !='0' ">
							备注：凌晨房订单最晚保留到上午六点，未完成支付将自动取消。
						</div>
					</div>
				</div>

				<!--线条-->
				<hr style="border:none; border-top:1px solid #F1F1F1;"></hr>
			</div>

			<!-- 当前订单 -->
			<div style=" height:0.7rem ;  margin-top:0.2rem ; margin-bottom:0.1rem">
				<div class='opBtn payBtn' v-if="orderOption(item).showPay " v-on:click="payMoney(item.ParentResvNo , item.TotalPrice , item.HoldTime  )">
					支付房费
				</div>
				<div v-if="orderOption(item).showCancel" class='opBtn' v-on:click="cancelOrder(item.ParentResvNo )">
					取消订单
				</div>
				<div v-else class='opBtn' v-on:click="deleteOrder(item.ParentResvNo )">
					删除订单
				</div>
			</div>

			<div style=" background-color: #F5F5F5 ;height: 0.2rem  ;  width:114% ; margin-left:-7%"></div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import orderHelper from "../utils/order";

export default {
  data() {
    return {
      // 弹出层
      TellUser: "",
      toast: false
    };
  },
  props: {
    orderList: {
      type: Array,
      required: true
    },
    showCurrent: {
      type: Boolean,
      default: true
    },
    useKCoin: {
      type: Boolean,
      default: false
    },
    CardKindDiplay: {
      type: String,
      default: "xxx"
    }
  },
  methods: {
    goDetail(OrderId, Money, TypeName) {
      this.$emit("goDetail", OrderId, Money, TypeName);
    },
    cancelOrder(ParentResvNo) {
      this.$emit("cancelOrder", ParentResvNo);
    },
    deleteOrder(ParentResvNo) {
      this.$emit("deleteOrder", ParentResvNo);
    },
    payMoney(OrderId, TotalPrice, startDate) {
      this.$emit("payMoney", OrderId, TotalPrice, startDate);
    },
    orderState(order) {
      //订单状态
      return orderHelper.getOrderState(order);
    },
    orderOption(order) {
      //订单操作
      return orderHelper.getOrderOption(order);
    }
  },
  computed: {
    ...mapGetters(["g_currentInfo"])
  }
};
</script>

<style lang="less" scoped>
@import "../assets/theme.less";
@import "../assets/common.less";
.opBtn {
  border: 1px solid #cccccc;
  font-size: 0.24rem;
  color: #999999;
  text-align: center;
  width: 1.67rem;
  height: 0.57rem;
  line-height: 0.57rem;
  float: right;
}
.payBtn {
  border: 1px solid #27ba69;
  color: #27ba69;
  margin-left: 1em;
}
</style>


// WEBPACK FOOTER //
// orderList.vue?4debe60e